// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { BottomField } from 'components/molecules/BottomField';
import LabelOrSelectField from 'components/molecules/LabelOrSelectField';
import styles from './CompressionRegistration.module.scss';
import { useTranslation } from 'react-i18next';
import { Option, UserCompressionCreateRequest } from 'util/Types';
import { FormApi } from 'final-form';
import { FormRenderProps } from 'react-final-form';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { useEffect, useState } from 'react';
import { ProcessingMode } from 'util/Enums';
import { createAxios } from 'ts/createAxios';
import { handleError } from 'util/errorHandler';

type CompressionInfoFormProps = {
  materialTypes: Option[];
  materialNameOptions: Option[];
  compressionMethod: Option[];
  grades: Option[];
  packingStyles: Option[];
  formProps: FormRenderProps<
    UserCompressionCreateRequest,
    Partial<UserCompressionCreateRequest>
  >;
  prevProcessingObjectId: string | undefined;
  resetFormData: (
    form: FormApi<
      UserCompressionCreateRequest,
      Partial<UserCompressionCreateRequest>
    >
  ) => void;
  setStep: (step: 'info' | 'weight' | 'regis') => void;
  weightLeftTitle: string;
  weightLeftValue: string;
  setTotalAutoInputResourcesWeight: (data: number) => void;
  totalAutoInputResourcesWeight: number;
  registeringProcessingObjectIds: string[];
};

const CompressionInfoForm: React.FC<CompressionInfoFormProps> = ({
  materialTypes,
  materialNameOptions,
  compressionMethod,
  grades,
  packingStyles,
  formProps,
  prevProcessingObjectId,
  resetFormData,
  setStep,
  weightLeftTitle,
  weightLeftValue,
  setTotalAutoInputResourcesWeight,
  totalAutoInputResourcesWeight,
  registeringProcessingObjectIds,
}) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const [isSettingMaster, setIsSettingMaster] = useState<boolean>(false);

  useEffect(() => {
    if (
      user.processingMode === ProcessingMode.Auto &&
      formProps.values.materialName &&
      formProps.values.type
    ) {
      createAxios()
        .post('/compressions/remain-input-weights', {
          materialName: formProps.values.materialName,
          type: formProps.values.type,
          processingObjectIds: registeringProcessingObjectIds,
        })
        .then((response) => {
          setTotalAutoInputResourcesWeight(response.data.remainInputWeight);
          setIsSettingMaster(response.data.isSettingMaster);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [
    user.processingMode,
    formProps.values.materialName,
    formProps.values.type,
  ]);

  return (
    <>
      <div className={styles.scrollContents}>
        <LabelOrSelectField
          options={materialNameOptions}
          label={t('emission_input.material_name')}
          fieldName="materialName"
        />

        <LabelOrSelectField
          options={materialTypes}
          label={t('emission_input.material_types')}
          fieldName="type"
          error={
            user.processingMode === ProcessingMode.Auto && !isSettingMaster
              ? t('messages.M_type_not_setting_master') || ''
              : undefined
          }
        />

        <LabelOrSelectField
          options={[]}
          label={weightLeftTitle}
          staticValue={`${weightLeftValue}kg`}
        />

        <LabelOrSelectField
          options={compressionMethod}
          label={t('emission_input.processing_method')}
          fieldName="processingMethod"
        />

        <LabelOrSelectField
          options={grades}
          label={t('emission_input.grade')}
          fieldName="gradeId"
        />

        <LabelOrSelectField
          options={packingStyles}
          label={t('emission_input.packing_style')}
          fieldName="packingStyle"
        />
      </div>

      <BottomField>
        <div className={styles.bottomBtn}>
          <button
            className={styles.back}
            onClick={() => {
              if (prevProcessingObjectId) {
                resetFormData(formProps.form);
              }

              setStep('regis');
            }}
          >
            {t('common.return')}
          </button>
          <button
            className={styles.btnRequest}
            type="button"
            onClick={() => setStep('weight')}
            disabled={
              user.processingMode === ProcessingMode.Auto &&
              !totalAutoInputResourcesWeight
            }
          >
            {t('common.button.next')}
          </button>
        </div>
      </BottomField>
    </>
  );
};

export default CompressionInfoForm;
